export default __webpack_public_path__ + "static/media/Correct-documentation.8bf40314.md";